/**
 * Label formatting utilities
 * Centralized label formatters for consistent UI text across the application
 */

import { WEEKDAY_KOREAN, LESSON_TYPE_LABELS } from '../../config/constants';

/**
 * Get Korean label for weekday
 * @param weekday - English weekday name (e.g., 'monday', 'tuesday')
 * @returns Korean weekday label (e.g., '월요일', '화요일')
 */
export const getWeekdayLabel = (weekday: string): string => {
  const normalizedWeekday = weekday.toLowerCase();
  return WEEKDAY_KOREAN[normalizedWeekday as keyof typeof WEEKDAY_KOREAN] || weekday;
};

/**
 * Get Korean label for lesson type
 * @param type - Lesson type (e.g., 'beginner', 'intermediate', 'advanced', 'kids')
 * @returns Korean lesson type label (e.g., '초급', '중급', '고급', '키즈')
 */
export const getLessonTypeLabel = (type: string): string => {
  return LESSON_TYPE_LABELS[type as keyof typeof LESSON_TYPE_LABELS] || type;
};
